export default __webpack_public_path__ + "static/media/4naly3erLight.e5804342.png";